// extracted by mini-css-extract-plugin
export default {"tableContainer":"ClientTable_tableContainer__sogi7","clientRow":"ClientTable_clientRow__VtNhv","icon":"ClientTable_icon__IRoN1","errorMessage":"ClientTable_errorMessage__ZkemI"};